import { IObjectConfig } from "../baseConfigs/layoutConfigShema";
import Layout from "../utils/Layout";
import Utils from "../utils/Utils";

export default class SceneViewContainer extends PIXI.Container {
    protected boundShape: PIXI.Graphics;
    protected maskShape: PIXI.Graphics;
    protected boundsConfig: IObjectConfig;
    protected autoscaleEnabled = true;

    constructor(bounds: IObjectConfig) {
        super();
        this.boundsConfig = bounds;
        this.boundShape = new PIXI.Graphics();
        this.boundShape.beginFill(0x000000, 0);
        this.boundShape.drawRect(0, 0, Layout.scalePixels(bounds.width), Layout.scalePixels(bounds.height));
        this.addChild(this.boundShape);
        this.maskShape = new PIXI.Graphics();
        this.maskShape.beginFill(0x000000, 1);
        this.maskShape.drawRect(0, 0, Layout.scalePixels(bounds.width), Layout.scalePixels(bounds.height));
        this.maskShape.endFill();
        this.maskShape.alpha = 0.01;
        // this.parent.addChild(this.maskShape);
        // this.addChild(this.maskShape);
        // this.maskShape.x = Layout.scalePixels(bounds.x);
        // this.maskShape.y = Layout.scalePixels(bounds.y);
        this.addChild(this.maskShape);
        // this.maskCont.addChild(this.maskShape);
        this.mask = this.maskShape;
        // this.maskCont.alpha = 0;

    }

    public dissableAutoScale() {
        this.autoscaleEnabled = false;
    }

    public enableAutoScale() {
        this.autoscaleEnabled = true;
    }

    public getMaskShape() {
        return this.maskShape;
    }

    public cleanup(){
        let toRemove = [];
        this.children.forEach(child =>{
            if(!(child==this.mask || child!=this.boundShape)){
                toRemove.push(child)
            }
        })
        toRemove.forEach(child=>{
            this.removeChild(child);
            child.destroy()
        })
    }
    public disableMask() {
        this.mask = null;
    }

    public enableMask() {
        this.mask = this.maskShape;
    }

    public getBoundShape(): PIXI.Graphics {
        return this.boundShape;
    }

    public getBoundConfig(): IObjectConfig {
        return Utils.deepClone(this.boundsConfig);
    }

    public changeBound(bounds: IObjectConfig) {
        if (!this.autoscaleEnabled) {
            return;
        }
        this.boundsConfig = bounds;
        this.scale.x = this.scale.y = 1;
        Layout.testSetWidth(this.boundShape, bounds.width, false);
        Layout.testSetHeight(this.boundShape, bounds.height, false);
        // Layout.testSetHeight(this.boundShape, bounds.height/multy,false);
        this.scale.x = this.scale.y = Math.max(this.boundShape.scale.x, this.boundShape.scale.y);
        this.boundShape.scale.x = this.boundShape.scale.y = 1;
        // this.maskShape.scale.x = this.maskShape.scale.x/1 ;
        // this.maskShape.scale.y =  this.maskShape.scale.y/1 ;
        let maskAspectRatio = Math.round((bounds.width / bounds.height + Number.EPSILON) * 100) / 100;
        let containerAspectRatio = Math.round((this.maskShape.width / this.maskShape.height + Number.EPSILON) * 100) / 100;
        let dif = Math.round(Math.abs(maskAspectRatio - containerAspectRatio) * 100) / 100;
        // if (dif > 0.03) {
        // if(maskAspectRatio!=containerAspectRatio) {
        // Layout.testSetWidth(this.maskShape, bounds.width/this.scale.x,false);
        // Layout.testSetHeight(this.maskShape, bounds.height/this.scale.x,false);

        // if(this.maskShape) {
        this.maskShape.clear();
        this.maskShape.beginFill(0x000000, 0.01);
        this.maskShape.drawRect(0, 0, Layout.scalePixels(bounds.width) / this.calculateTextMultiplier(), Layout.scalePixels(bounds.height) / this.calculateTextMultiplier());
        this.maskShape.endFill();
        // }
        // }
    }
    public changeSpineAnimBound(bounds: IObjectConfig, setBoundShapeScale = true) {
        if (!this.autoscaleEnabled) {
            return;
        }
        this.boundsConfig = bounds;
        this.scale.x = this.scale.y = 1;
        Layout.testSetWidth(this.boundShape, bounds.width, false);
        Layout.testSetHeight(this.boundShape, bounds.height, false);
        if (setBoundShapeScale) {
            this.scale.x = this.scale.y = Math.max(this.boundShape.scale.x, this.boundShape.scale.y);
        }
        this.boundShape.scale.x = this.boundShape.scale.y = 1;

        this.maskShape.clear();
        this.maskShape.beginFill(0x000000, 0.01);
        this.maskShape.drawRect(0, 0, Layout.scalePixels(bounds.width) / this.calculateTextMultiplier(), Layout.scalePixels(bounds.height) / this.calculateTextMultiplier());
        this.maskShape.endFill();
    }

    protected calculateTextMultiplier(): number {
        return this.scale.x;
    }


}
